var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4918",
    "data-name": "Group 4918",
    transform: "translate(-92 -676)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4883",
    "data-name": "Group 4883",
    transform: "translate(-137 -554)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4410",
    "data-name": "Path 4410",
    d: "M7,0A7,7,0,1,1,0,7,7,7,0,0,1,7,0Z",
    transform: "translate(229 1230)",
    fill: "#a6acb5",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14640",
    "data-name": "Rectangle 14640",
    width: 2,
    height: 5,
    rx: 1,
    transform: "translate(235 1236)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21124",
    "data-name": "Ellipse 21124",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(235 1233)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.d8b3adc0f586596c00e7f9b230b30f7f.svg";
export { ForwardRef as ReactComponent };